export const auditMissionListSelector = (state) => state.audit_missions.list
export const auditMissionPaginationSelector = (state) =>
  state.audit_missions.pagination
export const selectedAuditMissionSelector = (state) =>
  state.audit_missions.selected
export const auditMissionPerPageSelector = (state) =>
  state.audit_missions.per_page
export const auditMissionSearchSelector = (state) => state.audit_missions.search
